export default class ContactFormModel {
    public name?: string;
    public email?: string;
    public subject?: string;
    public message?: string;

    constructor(init?: Partial<ContactFormModel>) {
        if (init != undefined) {
            Object.shallowMerge(this, init);
        }
    }

    public clone() {
        return new ContactFormModel(this);
    }
}